export const RMS_SUBLIMITS_DATA = "RMS_SUBLIMITS_DATA";
export const RMS_HOLDING_DATA = "RMS_HOLDING_DATA";
export const RMS_SUBLIMITS_START_LOADER = "RMS_SUBLIMITS_START_LOADER";
export const RMS_SUBLIMITS_STOP_LOADER = "RMS_SUBLIMITS_STOP_LOADER";
export const RMS_HOLDING_START_LOADER = "RMS_HOLDING_START_LOADER";
export const RMS_HOLDING_STOP_LOADER = "RMS_HOLDING_STOP_LOADER";
export const RMS_DETAILS_ERROR_DATA = "RMS_DETAILS_ERROR_DATA";
export const RMS_DETAILS_HIDE_ERROR_DATA = "RMS_DETAILS_HIDE_ERROR_DATA";
